import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_dots-3",
  "use": "svg_dots-3-usage",
  "viewBox": "0 0 15 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 4\" id=\"svg_dots-3\"><path d=\"M7.5.875a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25ZM2.25 2A1.125 1.125 0 1 0 0 2a1.125 1.125 0 0 0 2.25 0Zm10.5 0A1.125 1.125 0 1 0 15 2a1.125 1.125 0 0 0-2.25 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol